import type { StatusPillProps, StatusTone } from '@/components/StatusPill/StatusPill';
import type { TransactionStatus } from '@/store/expenses-store/transactions/transactions.dto.ts';

const LABELS: Record<TransactionStatus, string> = {
  pending: 'Pending',
  processing: 'Processing',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Canceled',
  needs_approval: 'Needs Approval',
  waits_for_receiving: 'In Transit',
};

const TONES: Record<TransactionStatus, StatusTone> = {
  pending: 'progress',
  processing: 'progress',
  completed: 'success',
  failed: 'danger',
  cancelled: 'neutral',
  needs_approval: 'warning',
  waits_for_receiving: 'progress',
};

const humanize = (status: string) =>
  status
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');

export const transactionStatusLabel = (status?: string): string => {
  if (!status) return '-';
  return LABELS[status as TransactionStatus] ?? humanize(status);
};

export const transactionStatusTone = (status?: string): StatusTone => {
  if (!status) return 'neutral';
  return TONES[status as TransactionStatus] ?? 'neutral';
};

export const transactionStatusVariant = (status?: string): StatusPillProps['variant'] =>
  status === 'cancelled' ? 'outline' : 'solid';
